export default "__VITE_ASSET__QQAQXrCd__"